import UnknownPrototypeError from '@/errors/UnknownPrototypeError';
import Fitting from '@/models/Fitting';

export default class SetFittingPrototype
{
    /**
     * Vue Object
     */
    v = null;

    /** @type {"right"|"left"|null} */
    side = null;

    constructor(v, side)
    {
        this.v = v;
        this.side = side;
    }

    async handle()
    {
        const lensOrderUrlManager = this.v.lensOrderUrlManager;

        // Ignore sides with no prototype
        if(!lensOrderUrlManager.hasPrototypeCode(this.side))
        {
            return true;
        }

        /** @type {Fitting} */
        const fitting = this.v.$store.getters['lensOrder/getFitting'](this.side);
        const prototypeCode = lensOrderUrlManager.getPrototypeCode(this.side);

        // If there is a prototype or if the prototype has changed => set fitting prototype
        const proto = fitting.getPrototype();
        if(!proto || proto.code !== prototypeCode)
        {
            const prototypeAttributes = this.v.$store.getters['prototypes/getByCode'](prototypeCode);
            if(!prototypeAttributes)
            {
                throw new UnknownPrototypeError(prototypeCode);
            }

            fitting.setPrototype(prototypeAttributes);
            this.v.sides[this.side].prototypeCode = prototypeCode;

            console.log(`Fitting prototype has been set or updated for ${this.side} side.`, prototypeAttributes);
        }
        else
        {
            console.log(`Fitting prototype for ${this.side} side is the same as in last dispatch`);
        }

        return true;
    }
}
